import { getCountryFlag } from '@/pages/home/_config/countries';
import React from 'react';
import { Bubble } from 'tea-component';
import GameImage from '@/pages/home/components/GameImage';
import TableSelect from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/Financials/components/TableSelect';
import { unitConversion } from '@/pages/dashboard/utils/utils';
// import AppAnnie from '@/pages/intelligence/assets/svg/dataSource/app-annie.svg';
import Sensortower from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import '@/pages/intelligence/assets/scss/TopCharts/Companies/GamesDetails/similarCompanies.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';
import _ from 'lodash-es';
import TextBubbles from '@/pages/home/components/TextBubbles';
import { COMPANY_IPO_STATUS_LOCALE_KEYS } from '@intelligence/pages/TopCharts/Companies/utils';

import { getCountryCodeByCountryName } from '@/pages/intelligence/utils/commonUtils';

export const smilarCompaniesTableData = (
  cvmList: { [key: string]: unknown }[],
  setParamsDefault: (...args: any) => void | Function,
  formatMessage: (...args: any) => string | React.ReactElement,
  regionOptions: any[],
) => {
  // console.log(regionOptions);
  const handleOnSort = _.debounce(<T extends string | number>(key: T, value?: any) => {
    setParamsDefault((pre: any) => ({
      ...pre,
      [key]: value,
      page: 1,
    }));
  }, 800);
  const revenueMetricName = formatMessage({ id: 'dbi_revenue_$' }) as string;
  const mobileRevenueMetricName = formatMessage({
    id: 'dbi_company_metrics_mobile_revenue',
  }) as string;
  const pcRevenueMetricName = formatMessage({ id: 'dbi_company_metrics_pc_revenue' }) as string;
  const consoleRevenueMetricName = formatMessage({
    id: 'dbi_company_metrics_console_revenue',
  }) as string;
  return {
    cvmList: cvmList || [],
    columns: [
      {
        key: 'companies',
        width: 300,
        fixed: 'left',
        header: (
          <div className="table-title">
            <Bubble content="Companies" dark>
              {formatMessage({ id: 'dbi_company' })}
            </Bubble>
          </div>
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-cont">
            <div className="table-cont-img">
              <GameImage entityType="company" src={cvm?.imageUrl} />
            </div>
            <div className="table-cont-info">
              <TextBubbles className="table-cont-title" text={cvm.name} />
              <div className="table-cont-text">
                <img
                  src={getCountryFlag(
                    getCountryCodeByCountryName(regionOptions, cvm?.locationCountry, true),
                  )}
                  alt=""
                />
                <TextBubbles text={`${cvm.locationCity},${cvm.locationCountry}`} />
                {/* <span>{`${cvm.locationCity},${cvm.locationCountry}`}</span> */}
              </div>
            </div>
          </div>
        ),
      },
      {
        key: 'gameOwned',
        header: (
          <Bubble content="Game Owned" dark>
            {formatMessage({ id: 'dbi_company_game_owned' })}
          </Bubble>
        ),
        align: 'right',
        render: (cvm: any) => <div className="table-text">{cvm.game_cnt}</div>,
      },
      {
        key: 'listed',
        header: (
          <TableSelect
            type="Radio"
            title={formatMessage({ id: 'dbi_company_listed' })}
            nosearch={true}
            onChange={(value: any) => handleOnSort('listed', value)}
            isAll={false}
            checkList={[
              { name: '', text: formatMessage({ id: 'dbi_all' }) },
              { name: 'Delisted', text: formatMessage({ id: 'dbi_company_delisted' }) },
              { name: 'Private', text: formatMessage({ id: 'dbi_company_private' }) },
              { name: 'Public', text: formatMessage({ id: 'dbi_company_public' }) },
            ]}
          />
        ),
        align: 'left',
        width: 120,
        render: (cvm: any) => {
          const ipoStatus = cvm?.ipoStatus;
          const ipoStatusLocaleKey = COMPANY_IPO_STATUS_LOCALE_KEYS[ipoStatus];
          const ipoStatusName = ipoStatusLocaleKey
            ? formatMessage({ id: ipoStatusLocaleKey })
            : ipoStatus;
          return <div className="table-text">{ipoStatusName}</div>;
        },
      },
      {
        key: 'totalsOrder',
        header: (
          <div className="table-header">
            <Bubble content={revenueMetricName} dark>
              {revenueMetricName}
            </Bubble>
          </div>
        ),
        align: 'center',
        render: (cvm: any) => (
          <div className="table-row-center">
            <div className="table-row-center-inner">
              <span className="table-row-title">{unitConversion(cvm.totals) || 0}</span>
              <span className={cvm.totals >= 50 ? 'table-row-successnum' : 'table-row-errornum'}>
                {`${(cvm.ratio * 100).toFixed(0)}%`}
              </span>
              <SvgIcon
                type={cvm.totals >= 50 ? 'green-up-new' : 'red-down-new'}
                className="table-row-arrow"
              />
            </div>
          </div>
        ),
      },
      {
        key: 'mobileOrder',
        header: (
          <div className="table-header">
            <img src={Sensortower} className="header-icon" />
            <Bubble content={mobileRevenueMetricName} dark>
              <span className="table-header-text">{mobileRevenueMetricName}</span>
            </Bubble>
          </div>
        ),
        align: 'right',
        render: (cvm: any) => <div className="table-text">{unitConversion(cvm.gameRevenue)}</div>,
      },
      {
        key: 'pcOrder',
        header: (
          <Bubble content={pcRevenueMetricName} dark>
            {pcRevenueMetricName}
          </Bubble>
        ),
        align: 'right',
        render: (cvm: any) => <div className="table-text">{unitConversion(cvm.pcRevenue)}</div>,
      },

      {
        key: 'consoleOrder',
        header: (
          <Bubble content={consoleRevenueMetricName} dark>
            {consoleRevenueMetricName}
          </Bubble>
        ),
        align: 'right',
        render: (cvm: any) => (
          <div className="table-text">{unitConversion(cvm.consoleRevenue)}</div>
        ),
      },
    ],
    addonscolumns: ['gameOwned', 'totalsOrder', 'pcOrder', 'mobileOrder', 'consoleOrder'],
  };
};
